import { render, staticRenderFns } from "./ClockDisplay.vue?vue&type=template&id=5de4e901&scoped=true&"
import script from "./ClockDisplay.vue?vue&type=script&lang=js&"
export * from "./ClockDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ClockDisplay.vue?vue&type=style&index=0&id=5de4e901&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de4e901",
  null
  
)

export default component.exports